
import { useState} from "react";
import { NavLink, Link, } from "react-router-dom";


function Navbar() {
     const [isOpen, setIsOpen] = useState(false);

    return(

<nav className="sticky top-0 z-50 bg-beige/80 backdrop-blur-lg text-brown px-6 py-4 shadow-sm">
      <div className="flex items-center justify-between  mx-auto">
        {/* Namn*/}
        <div>
          <Link to="/" className="text-2xl font-serif tracking-wide" onClick={() => setIsOpen(false)}>CLAIRÉ</Link>
        </div>

        {/* Mobil: Boka + Hamburger */}
        <div className="flex items-center gap-3 lg:hidden">
          <a href="https://bokning.voady.se/studioclaire">
          <button className="bg-beige-dark px-8 py-2 rounded-full text-md font-medium  leading-none hover:bg-brown hover:text-beige transition cursor-pointer">
            Boka tid
          </button>
          </a>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="relative w-8 h-8"
            >
                  {/* Hamburgare */}
                  <span
                    className={`
                      absolute inset-0 flex items-center justify-center
                      transition-all duration-500 ease-in-out text-3xl
                      ${isOpen ? "opacity-0 rotate-90 scale-75" : "opacity-100 rotate-0 scale-100"}
                    `}
                  >
                    ☰
                  </span>

                  {/* X */}
                  <span
                    className={`
                      absolute inset-0 flex items-center justify-center
                      transition-all duration-500 ease-in-out text-3xl
                      ${isOpen ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-75"}
                    `}
                  >
                    ✕
                  </span>
            </button>
        </div>

        {/* Desktop menu */}
        <div className="hidden lg:flex items-center space-x-8 text-md uppercase tracking-widest">
          <NavLink to="/" className="hover:text-brown-dark transition">Hem</NavLink> 
          <NavLink to="/tjanster" className="hover:text-brown-dark transition">Tjänster</NavLink> 
          <NavLink to="/omoss" className="hover:text-brown-dark transition">Om oss</NavLink> 
          <NavLink to="/kontakt" className="hover:text-brown-dark transition">Kontakt</NavLink> 
          <NavLink to="/bokningsvillkor" className="hover:text-brown-dark transition">Bokningsvillkor</NavLink> 

          {/* Desktop Boka */}
          <a href="https://bokning.voady.se/studioclaire" className="ml-4 bg-beige-dark px-5 py-2 rounded-full hover:bg-brown hover:text-beige transition font-medium cursor-pointer">
            Boka tid
          </a>
        </div>
      </div>

      {/* Mobilmeny */}
<div
  className={`
    lg:hidden
    overflow-hidden
    transition-all
    duration-500
    
    ease-in-out

    ${isOpen ? "max-h-96 opacity-100 translate-y-0" : "max-h-0 opacity-0 -translate-y-2"}
  `}
>
  <div className="mt-4 bg-beige-light rounded-xl p-4 space-y-3 text-md uppercase tracking-widest flex flex-col items-center">
    <NavLink to="/" className="block hover:text-brown-dark" onClick={() => setIsOpen(false)}>Hem</NavLink>
    <NavLink to="/tjanster" className="block hover:text-brown-dark" onClick={() => setIsOpen(false)}>Tjänster</NavLink>
    <NavLink to="/omoss" className="block hover:text-brown-dark" onClick={() => setIsOpen(false)}>Om oss</NavLink>
    <NavLink to="/kontakt" className="block hover:text-brown-dark" onClick={() => setIsOpen(false)}>Kontakt</NavLink> 
    <NavLink to="/bokningsvillkor" className="block hover:text-brown-dark" onClick={() => setIsOpen(false)}>Bokningsvillkor</NavLink> 
  </div>
</div>
    </nav>
    );
}

export default Navbar;